module.exports = __webpack_public_path__ + "static/img/qiaoliang.66ae4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/qiaoliang.png
// module id = /Wmc
// module chunks = 1